import Vue from 'vue'
export default {
  namespaced: true,
  state: {
    messageDetails: {}
  },
  mutations: {
    setMessageDetails(state, data) {
      state.messageDetails = data
    }
  },
  actions: {

  },
  getters: {

  },
}
